import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useJobPostContext } from "@/providers/contexts";

const RedirectToHomeAndOpenJobModal = () => {
  const [searchParams] = useSearchParams();
  const jobId = searchParams.get("id");
  const navigate = useNavigate();
  const { setJobPostId, setJobPostDetailsModalOpen } = useJobPostContext();

  useEffect(() => {
    if (jobId) {
      setJobPostId(Number(jobId));
      setJobPostDetailsModalOpen(true);
    }
    navigate("/", { replace: true });
  }, [jobId, navigate, setJobPostId, setJobPostDetailsModalOpen]);

  return null;
};

export default RedirectToHomeAndOpenJobModal;
